import React from "react";

const Occupancy = () => <div />;

export default Occupancy;
